import React from "react";
import { Card } from "react-bootstrap";

const alerts = [
  {
    type: "danger",
    message:
      "31 critical queries open — oldest is 175 days (Q-100010 on 04-011).",
    date: "10 Jun 2026 10:30",
  },
  {
    type: "danger",
    message: "8 critical queries pending PI response — escalation recommended.",
    date: "10 Jun 2026 10:30",
  },
  {
    type: "danger",
    message: "147 queries have breached SLA (75 open > 30 days).",
    date: "10 Jun 2026 10:30",
  },
  {
    type: "warning",
    message:
      "88 open queries on frozen/locked forms — blocking freeze/lock workflow.",
    date: "10 Jun 2026 10:30",
  },
  {
    type: "warning",
    message:
      "9 queries re-opened more than once — review response quality with sites.",
    date: "10 Jun 2026 10:30",
  },
  {
    type: "warning",
    message:
      "Site 02 has 82 unresolved queries — highest backlog in the study; consider CRA follow-up visit.",
    date: "10 Jun 2026 10:30",
  },
  {
    type: "info",
    message:
      'Repeated field-level issue: "Adverse Events › AE Start Date" has generated 30 queries across subjects — review edit check design / site training.',
    date: "10 Jun 2026 10:30",
  },
  {
    type: "info",
    message:
      "93 subjects not yet ready for database lock (≥1 unresolved query).",
    date: "10 Jun 2026 10:30",
  },
];

const QueryAlerts = () => {
  return (
    <div className="query-alerts">
      {alerts.map((alert, index) => (
        <Card key={index} className={`bg-${alert.type}-subtle mb-2 app-card`}>
          <Card.Body className="py-2 px-3 hstack justify-content-between">
            <div className="hstack gap-3">
              <i className={`fa-solid fa-circle text-${alert.type}`}></i>
              <div className="small">{alert.message}</div>
            </div>
            <small className="text-muted text-nowrap">{alert.date}</small>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default QueryAlerts;
